import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarIcon, MousePointerClickIcon, SmileIcon, TruckIcon } from 'lucide-react';
import { ProductCard } from '../components/ProductCard';
import { loadProducts, getSupabaseErrorMessage } from '../data/repository';
import { Product } from '../data/types';
const steps = [{
  icon: MousePointerClickIcon,
  title: 'Odaberite napuhanac',
  desc: 'Pregledajte našu ponudu i odaberite savršenu opremu za zabavu.'
}, {
  icon: CalendarIcon,
  title: 'Rezervirajte termin',
  desc: 'Odaberite datum i rezervirajte u par klikova.'
}, {
  icon: TruckIcon,
  title: 'Dostava ili osobno preuzimanje',
  desc: 'Odaberite dostavu s postavljanjem ili sami preuzmite napuhanac.'
}, {
  icon: SmileIcon,
  title: 'Uživajte!',
  desc: 'Prepustite se zabavi i stvorite uspomene.'
}];
export function Home() {
  const [products, setProducts] = useState<Product[]>([]);
  const [error, setError] = useState('');
  useEffect(() => {
    void loadProducts().then(items => setProducts(items.filter(item => item.isActive !== false))).catch(loadError => setError(getSupabaseErrorMessage(loadError)));
  }, []);
  const heroProduct = products[0];
  const heroImage = heroProduct?.image || 'https://cdn.magicpatterns.com/uploads/spCZoxS6xDvhHFCXe1ab23/IMG_2597.jpg';
  return <div className="min-h-screen bg-background" data-id="element-614" data-mp="2hyywq838d5we">
      <section className="border-b border-gray-100 bg-white py-14 sm:py-20" data-id="element-615" data-mp="2hzqlayyeu3d6">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 lg:grid-cols-2 lg:px-8" data-id="element-616" data-mp="2d5w3k12d7ygq">
          <div className="text-center lg:text-left" data-id="element-617" data-mp="288dp5v5kwr1c">
            <p className="inline-flex rounded-full bg-primary/10 px-4 py-2 text-sm font-bold text-primary" data-id="element-618" data-mp="239j7iwjcl8it">
              Najbolja zabava u gradu
            </p>
            <h1 className="mt-6 text-5xl font-display font-bold leading-[0.95] text-gray-900 sm:text-6xl xl:text-7xl" data-id="element-619" data-mp="1z98tqxpbddte">
              Zabava koja
              <span className="block text-primary" data-id="element-620" data-mp="1kkh48btwt7ia">skače od sreće.</span>
            </h1>
            <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-gray-600 lg:mx-0 xl:text-xl" data-id="element-621" data-mp="1omu2yga8o55k">
              Najam napuhanaca i soft play igraonica za rođendane, proslave i
              dane koje djeca dugo pamte.
            </p>
            <div className="mt-9 flex flex-col justify-center gap-4 sm:flex-row lg:justify-start" data-id="element-622" data-mp="1fm5v63bfv114">
              <Link to="/rezervacija" className="rounded-2xl bg-primary px-8 py-4 text-lg font-bold text-white transition-colors hover:bg-[#0AC2DC]" data-id="element-623" data-mp="23bqewoff22bg">
                Rezerviraj odmah
              </Link>
              <Link to="/ponuda" className="rounded-2xl border border-gray-200 bg-white px-8 py-4 text-lg font-bold text-gray-900 transition-colors hover:bg-gray-50" data-id="element-624" data-mp="1yjyp4g4340md">
                Pogledaj ponudu
              </Link>
            </div>
            <div className="mt-9 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-bold text-gray-600 lg:justify-start" data-id="element-625" data-mp="flu0ozt0ryg8">
              <span data-id="element-626" data-mp="anirmrajtrz2">✓ Dostava i postavljanje</span>
              <span data-id="element-627" data-mp="akmrqxf54t7z">✓ Sigurna zabava</span>
              <span data-id="element-628" data-mp="oedsphet34s3">✓ Brza rezervacija</span>
            </div>
          </div>

          <div className="relative mx-auto w-full max-w-xl" data-id="element-629" data-mp="kcslocoydkpt">
            <div className="absolute -right-3 -top-3 h-28 w-28 rounded-full bg-primary/15 sm:h-36 sm:w-36" data-id="element-630" data-mp="kdc21oyyg11q" />
            <div className="absolute -bottom-4 -left-4 h-20 w-20 rounded-full bg-yellow-200 sm:h-28 sm:w-28" data-id="element-631" data-mp="3sugczd0ud7x8" />
            <div className="relative overflow-hidden rounded-[2rem] border-8 border-white bg-gray-100 shadow-xl" data-id="element-632" data-mp="3nvlvqfiivrf8">
              <img src={heroImage} alt={heroProduct?.name || 'JumpLand napuhanac spreman za zabavu'} className="aspect-[4/3] w-full object-cover" data-id="element-633" data-mp="ot9cxeqq5ia" />
              <div className="absolute bottom-4 left-4 rounded-2xl bg-white px-4 py-3 text-left shadow-lg" data-id="element-634" data-mp="1c486c16y8xde">
                <p className="text-xs font-bold uppercase tracking-wide text-primary" data-id="element-635" data-mp="27eoiq60qxmrb">
                  JumpLand
                </p>
                <p className="mt-1 font-display text-lg font-bold text-gray-900" data-id="element-636" data-mp="2cdhspogtqvmq">
                  Spremni za skakanje!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-20 bg-white" data-id="element-637" data-mp="2m8t01lpwl0kg">
        <div className="max-w-7xl mx-auto px-4" data-id="element-638" data-mp="2qdiur78ts93s">
          <div className="text-center mb-12" data-id="element-639" data-mp="2qaobhj1jsuby">
            <h2 className="text-4xl font-display font-bold text-gray-900" data-id="element-640" data-mp="2vb2884xp8huo">
              Kako funkcionira?
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-641" data-mp="303c6c88ywo81">
            {steps.map(step => {
            const Icon = step.icon;
            return <article key={step.title} className="rounded-3xl border border-gray-100 p-7 text-center" data-id="element-642" data-mp="3a21cx4veym8z">
                  <span className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary" data-id="element-643" data-mp="12eqbeu6ev5y5">
                    <Icon size={28} data-id="element-644" data-mp="yclgzt8525ag" />
                  </span>
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-645" data-mp="te1sbl25ufee">
                    {step.title}
                  </h3>
                  <p className="mt-3 text-gray-600" data-id="element-646" data-mp="og08gxwwuc1v">{step.desc}</p>
                </article>;
          })}
          </div>
        </div>
      </section>
      <section className="py-20" data-id="element-647" data-mp="1h3w4s1iki1y4">
        <div className="max-w-7xl mx-auto px-4" data-id="element-648" data-mp="1h3mh4kkzw6vl">
          <div className="text-center mb-12" data-id="element-649" data-mp="1h5z2z8tvj1dx">
            <h2 className="text-4xl font-display font-bold text-gray-900" data-id="element-650" data-mp="1cce3tdgjo1d5">
              Naša ponuda
            </h2>
          </div>
          {error ? <RemoteError message={error} data-id="element-651" data-mp="17c8isg4s5d41" /> : products.length === 0 ? <p className="text-center text-gray-500" data-id="element-652" data-mp="24urw6xj42v4u">Učitavamo ponudu…</p> : <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-653" data-mp="2015nfgg2jbeb">
              {products.map((product, index) => <ProductCard key={product.id} product={product} index={index} data-id="element-654" data-mp="26s4fbw25k23" data-mpi={index} />)}
            </div>}
        </div>
      </section>
    </div>;
}
function RemoteError({
  message
}: {
  message: string;
}) {
  return <p role="alert" className="mx-auto max-w-2xl rounded-2xl border border-red-200 bg-red-50 p-5 text-center text-red-800" data-id="element-655" data-mp="3piu8vw4txmg9">
      {message}
    </p>;
}